import Icon from '@ant-design/icons';

const TimerSvg = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.93752 3.4375H7.50002V16.5625H5.93752V3.4375ZM13.9063 3.4375H12.6563C12.5703 3.4375 12.5 3.50781 12.5 3.59375V16.4062C12.5 16.4922 12.5703 16.5625 12.6563 16.5625H13.9063C13.9922 16.5625 14.0625 16.4922 14.0625 16.4062V3.59375C14.0625 3.50781 13.9922 3.4375 13.9063 3.4375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TimerPause = (props: any) => <Icon component={TimerSvg} {...props} />;
